import React from "react";
import { UseFormRegisterReturn } from "react-hook-form";
import AlertCircleIcon from "@/shared/icons/AlertCircleIcon";
import GeneralInputWrapper from "../GeneralInputWrapper/GeneralInputWrapper";
import { FieldSettings, WuiltContext } from "@/shared/types";

interface TextInputProps {
  registerProps: UseFormRegisterReturn;
  isError?: boolean;
  fieldSettings: FieldSettings;
  id: string;
  text?: any;
  wuiltContext?: WuiltContext;
}

const TextInput: React.FC<TextInputProps> = ({
  registerProps,
  isError,
  fieldSettings,
  id,
  text,
  wuiltContext,
}) => {
  return (
    <GeneralInputWrapper isError={isError} wuiltContext={wuiltContext}>
      <input
        id={id}
        placeholder={text[fieldSettings?.placeholder?.textId!]}
        min={fieldSettings?.min}
        max={fieldSettings?.max}
        minLength={fieldSettings?.minLength}
        maxLength={fieldSettings?.maxLength}
        {...registerProps}
        autoComplete={fieldSettings?.autoComplete}
      />
      {isError && <AlertCircleIcon />}
    </GeneralInputWrapper>
  );
};

export default TextInput;
